import React from 'react'

import { decodeScriptField } from '@/utilities/scriptFieldCodec'

import { Code } from './Component.client'

export type CodeBlockProps = {
  code: string
  language?: string
  blockType: 'code'
}

type Props = CodeBlockProps & {
  className?: string
}

export const CodeBlock: React.FC<Props> = ({ className, code, language }) => {
  return (
    <div className={[className, 'not-prose'].filter(Boolean).join(' ')}>
      <Code code={decodeScriptField(code)} language={language} />
    </div>
  )
}
